import { InstanceData, InstanceDataType } from '@/framework/data';

/** 获取选中图层信息 */
export const getSelectedInfo = (identity: string, key: string) => {
    if (!key) return null;
    return InstanceData.getData(identity, InstanceDataType.SelectedInfo)?.[key] as Set<string>;
};

/** 设置选中图层信息 */
export const setSelectedInfo = (identity: string, key: string, data: Set<string>) => {
    let res: Record<string, unknown> = InstanceData.getData(identity, InstanceDataType.SelectedInfo);
    if (!res) {
        res = {};
        InstanceData.setData(identity, InstanceDataType.SelectedInfo, res);
    }
    res[key] = data;
};

/** 删除选中图层信息 */
export const delSelectedInfo = (identity: string, key: string) => {
    const res: Record<string, unknown> = InstanceData.getData(identity, InstanceDataType.SelectedInfo);
    if (!res) return;
    delete res[key];
};
